<div class="informative" id="financial-container">
  <po-widget class="po-lg-3 po-md-3 po-sm-12 po-mt-2 po-clickable" p-primary-label="+ Detalhes"
    p-title="Valor total a Pagar">
    <div class="icon-loading" *ngIf="loadingTotalPagar">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loadingTotalPagar && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div *ngIf="!loadingTotalPagar">
      <div class="po-font-subtitle po-text-center po-mt-2 value-red">
        <span class="po-font-text-small">R$ </span>
        <span><b>{{itemTotalPagar}}</b></span>
      </div>
      <div class="po-text-right po-pr-1 po-mt-2">
        <span class="po-mr-3">Semana</span>
        <span class="po-font-text-small po-mr-1">R$</span>
        <span class="value-blue"><b>{{itemTotalPagarSemana}}</b></span>
      </div>
      <div class="po-text-right po-pr-1">
        <span class="po-mr-3">Mês</span>
        <span class="po-font-text-small po-mr-1">R$</span>
        <span><b>{{itemTotalPagarMes}}</b></span>
      </div>
      <div class="po-text-right po-pr-1">
        <span class="po-mr-3">Ano</span>
        <span class="po-font-text-small po-mr-1">R$</span>
        <span><b>{{itemTotalPagarAno}}</b></span>
      </div>
    </div>
  </po-widget>
  <po-widget class="po-lg-3 po-md-3 po-sm-12 po-mt-2 po-clickable" p-primary-label="+ Detalhes"
    p-title="Valor total a Receber">
    <div class="icon-loading" *ngIf="loadingTotalReceber">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loadingTotalReceber">
      <div class="po-font-subtitle po-text-center po-mt-2 value-green">
        <span class="po-font-text-small">R$ </span>
        <span><b>{{itemTotalReceber}}</b></span>
      </div>
      <div class="po-text-right po-pr-1 po-mt-2">
        <span class="po-mr-3">Semana</span>
        <span class="po-font-text-small po-mr-1">R$ </span>
        <span class="value-blue"><b>{{itemTotalReceberSemana}}</b></span>
      </div>
      <div class="po-text-right po-pr-1">
        <span class="po-mr-3">Mês</span>
        <span class="po-font-text-small po-mr-1">R$ </span>
        <span><b>{{itemTotalReceberMes}}</b></span>
      </div>
      <div class="po-text-right po-pr-1">
        <span class="po-mr-3">Ano</span>
        <span class="po-font-text-small po-mr-1">R$ </span>
        <span><b>{{itemTotalReceberAno}}</b></span>
      </div>
    </div>
  </po-widget>
  <po-widget class="po-lg-3 po-md-3 po-sm-12 po-mt-2 po-clickable" p-primary-label="+ Detalhes"
    p-title="Prazo médio de pagamento">
    <div class="icon-loading" *ngIf="loadingPrazoPagamento">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loadingPrazoPagamento">
      <div class="po-font-subtitle po-text-center po-mt-5 value-red">
        <span><b>{{itemPrazoPagamento}} dias</b></span>
      </div>
    </div>
  </po-widget>
  <po-widget class="po-lg-3 po-md-3 po-sm-12 po-mt-2 po-clickable" p-primary-label="+ Detalhes"
    p-title="Prazo médio de recebimento">
    <div class="icon-loading" *ngIf="loadingPrazoRecebimento">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loadingPrazoRecebimento">
      <div class="po-font-subtitle po-text-center po-mt-5 value-green">
        <span><b>{{itemPrazoRecebimento}} dias</b></span>
      </div>
    </div>
  </po-widget>
</div>